import * as React from 'react';
import { SVGProps } from 'react';

const IconPasteSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 2a2 2 0 0 0-2 2h-1a1 1 0 0 0-1 1v3h8V5a1 1 0 0 0-1-1h-1a2 2 0 0 0-2-2ZM10 12v2h8v-2h-8ZM16 16h-6v2h6v-2Z" />
    <path d="M5 8a2 2 0 0 1 2-2h1v17h12V6h1a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8Z" />
  </svg>
);
export default IconPasteSizeL;
